import { render, staticRenderFns } from "./doc.vue?vue&type=template&id=f31cfbdc"
import script from "./doc.vue?vue&type=script&lang=js"
export * from "./doc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports